import {
    ROUTE_TO_VIEW_DEFINITIONS_OPX,
    ROUTE_TO_VIEW_DEFINITIONS_OPXDEEPLINK,
} from './routeViewNames';
import type { OpxViewNames } from './routeViewNames';

/**
 * Determines if path matches a given route:
 * `/opx/${opxdeeplinkView}` or /opx/<mailbox>/${opxdeeplinkView}` or `/opxdeeplink/{opxdeeplinkView}`
 *  and returns the associated HostedScenario value
 *
 */
const OPX_VDIR = 'opx';
const OPXDEEPLINK_URL_SEGMENT = 'opxdeeplink';

export function getHostedScenarioByUrl(): string | undefined {
    const path = window.location ? window.location.pathname : '';
    const segments = path.split('/');
    const opxSegment = segments.indexOf(OPX_VDIR);
    if (opxSegment >= 0 && segments.length > opxSegment + 1) {
        let nextSegment = opxSegment + 1;
        if (segments[nextSegment].match(/.+@.+/)) {
            nextSegment += 1;
        }
        const route = segments[nextSegment] as OpxViewNames;
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2551 (29,46): Property 'MyDay' does not exist on type 'RouteToViewDefinitionsOpx'. Did you mean 'myday'? ...
        // @ts-expect-error
        return ROUTE_TO_VIEW_DEFINITIONS_OPX[route];
    }
    const opxdeeplinkSegment = segments.indexOf(OPXDEEPLINK_URL_SEGMENT);
    if (opxdeeplinkSegment >= 0 && segments.length > opxdeeplinkSegment + 1) {
        const route = segments[opxdeeplinkSegment + 1] as OpxViewNames;
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS7053 (37,16): Element implicitly has an 'any' type because expression of type 'OpxViewNames' can't be used to index type 'RouteToViewDefinitionsOpxDeeplink'.
        // @ts-expect-error
        return ROUTE_TO_VIEW_DEFINITIONS_OPXDEEPLINK[route];
    }

    return undefined;
}
